<template>
  <div class="pave-worksheet-container">
    
    <div class="common-section-content gap-sm">
      <div class="grid gap-sm1" :style="$global.dynamicColsV2(.5, 1, 1, 1)">
        <div class="flex flex-column mb-2" v-for="col in colHeaders" :key="col.title">
          <div class="header-text-info">{{ col.title }}</div>
          <span class="text-sm">{{ col.subLabel || "" }}</span>
        </div>
      </div>
      <div class="d-flex flex-column gap-xs">
        <div class="grid gap-sm" v-for="(pave, index) in paveArr" :key="index" :style="$global.dynamicColsV2(.5, 1, 1, 1)">
          <div>{{ pave.label === 'En Vironment' ? 'enVironment' : pave.label }}</div>
          <div v-for="(field, index) in pave.fields" :key="index">
            <textarea rows="2" placeholder="Type here..." v-model="form[field]" style="resize: none;"></textarea>
          </div>
        </div>
      </div>
    </div>
    
    <div>
      <button class="primary" @click="$emit('next')">Finish</button>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      form: {},
      paveArr: [],
      colHeaders: [
        { title: 'PAVE' },
        { title: 'Perceive', subLabel: 'What hazards exist for this flight?' },
        { title: 'Process', subLabel: 'Evaluate risk level for hazards' },
        { title: 'Perform', subLabel: 'Implement steps to manage risk' },
      ]
    };
  },
  mounted() {
    const rows = ['pilot', 'aircraft', 'enVironment', 'externalPressure'];
    rows.forEach(row => {
      this.paveArr.push({
        label: this.$global.formatCamelCase(row),
        fields: [`${row}Perceive`, `${row}Process`, `${row}Perform`]
      });
    });
  }
};
</script>

<style>
.pave-worksheet-container {
  min-width: 750px;
}
.text-sm {
  font-size: 14px;
}
</style>
